export default __webpack_public_path__ + "static/media/Heebo-Medium.25066a08.woff";